import {normalizeTerrainSettings,validateTerrainSettings,type TerrainSettings} from '../config/terrainSettings.js';

const key=(account:string,farm:string)=>'sonata-terrain-settings:'+JSON.stringify([account,farm]);
/** Appearance only; this cache never authorizes a property or a prepared map. */
export function cacheTerrainSettings(account:string,farm:string,settings:TerrainSettings){
 try{localStorage.setItem(key(account,farm),JSON.stringify(normalizeTerrainSettings(settings)));}catch{/* Device storage is optional. */}
}
export function readCachedTerrainSettings(account:string,farm:string):TerrainSettings|null{
 try{const value:unknown=JSON.parse(localStorage.getItem(key(account,farm))||'null');return validateTerrainSettings(value)?null:normalizeTerrainSettings(value as TerrainSettings);}catch{return null;}
}
